export default __webpack_public_path__ + "static/media/AIML Icon.108b536d.svg";